// test1452
(1452 && 0);
